const geoData = {
  "México": {
    "Aguascalientes": ["Aguascalientes", "Jesús María", "Calvillo", "Rincón de Romos"],
    "Baja California": ["Tijuana", "Mexicali", "Ensenada", "Rosarito", "Tecate"],
    "Baja California Sur": ["La Paz", "Los Cabos", "Loreto", "Comondú"],
    "Campeche": ["Campeche", "Ciudad del Carmen", "Champotón", "Calkiní"],
    "Chiapas": ["Tuxtla Gutiérrez", "San Cristóbal de las Casas", "Tapachula", "Comitán", "Palenque"],
    "Chihuahua": ["Chihuahua", "Ciudad Juárez", "Delicias", "Cuauhtémoc", "Parral"],
    "Ciudad de México": ["Álvaro Obregón", "Azcapotzalco", "Benito Juárez", "Coyoacán", "Cuajimalpa", "Cuauhtémoc", "Gustavo A. Madero", "Iztacalco", "Iztapalapa", "Magdalena Contreras", "Miguel Hidalgo", "Milpa Alta", "Tláhuac", "Tlalpan", "Venustiano Carranza", "Xochimilco"],
    "Coahuila": ["Saltillo", "Torreón", "Monclova", "Piedras Negras", "Acuña"],
    "Colima": ["Colima", "Manzanillo", "Tecomán", "Villa de Álvarez"],
    "Durango": ["Durango", "Gómez Palacio", "Lerdo", "Santiago Papasquiaro"],
    "Estado de México": ["Toluca", "Ecatepec", "Naucalpan", "Nezahualcóyotl", "Tlalnepantla", "Atizapán", "Huixquilucan", "Metepec", "Coacalco", "Texcoco"],
    "Guanajuato": ["León", "Guanajuato", "Irapuato", "Celaya", "Salamanca", "San Miguel de Allende"],
    "Guerrero": ["Acapulco", "Chilpancingo", "Taxco", "Iguala", "Zihuatanejo"],
    "Hidalgo": ["Pachuca", "Tulancingo", "Tula", "Huejutla", "Tepeji del Río"],
    "Jalisco": ["Guadalajara", "Zapopan", "Tlaquepaque", "Tonalá", "Puerto Vallarta", "Tlajomulco", "Lagos de Moreno"],
    "Michoacán": ["Morelia", "Uruapan", "Zamora", "Lázaro Cárdenas", "Pátzcuaro", "Zitácuaro"],
    "Morelos": ["Cuernavaca", "Jiutepec", "Cuautla", "Temixco", "Yautepec"],
    "Nayarit": ["Tepic", "Bahía de Banderas", "Santiago Ixcuintla", "Compostela"],
    "Nuevo León": ["Monterrey", "San Pedro Garza García", "San Nicolás", "Guadalupe", "Apodaca", "Santa Catarina", "García"],
    "Oaxaca": ["Oaxaca de Juárez", "Salina Cruz", "Juchitán", "Huatulco", "Tuxtepec"],
    "Puebla": ["Puebla", "Tehuacán", "San Andrés Cholula", "San Pedro Cholula", "Atlixco"],
    "Querétaro": ["Querétaro", "San Juan del Río", "El Marqués", "Corregidora", "Tequisquiapan"],
    "Quintana Roo": ["Cancún", "Playa del Carmen", "Chetumal", "Tulum", "Cozumel", "Isla Mujeres"],
    "San Luis Potosí": ["San Luis Potosí", "Ciudad Valles", "Soledad de Graciano Sánchez", "Matehuala", "Rioverde"],
    "Sinaloa": ["Culiacán", "Mazatlán", "Los Mochis", "Guasave", "Navolato"],
    "Sonora": ["Hermosillo", "Ciudad Obregón", "Nogales", "Guaymas", "Navojoa", "Puerto Peñasco"],
    "Tabasco": ["Villahermosa", "Cárdenas", "Comalcalco", "Macuspana", "Paraíso"],
    "Tamaulipas": ["Reynosa", "Matamoros", "Tampico", "Ciudad Victoria", "Nuevo Laredo", "Ciudad Madero"],
    "Tlaxcala": ["Tlaxcala", "Apizaco", "Huamantla", "San Pablo del Monte", "Chiautempan"],
    "Veracruz": ["Veracruz", "Xalapa", "Coatzacoalcos", "Córdoba", "Orizaba", "Poza Rica", "Boca del Río"],
    "Yucatán": ["Mérida", "Valladolid", "Tizimín", "Progreso", "Umán", "Kanasín"],
    "Zacatecas": ["Zacatecas", "Fresnillo", "Guadalupe", "Jerez", "Río Grande"]
  },
  "Colombia": {
    "Amazonas": ["Leticia"],
    "Antioquia": ["Medellín", "Bello", "Envigado", "Itagüí", "Rionegro", "Sabaneta"],
    "Atlántico": ["Barranquilla", "Soledad", "Malambo"],
    "Bogotá D.C.": ["Bogotá"],
    "Bolívar": ["Cartagena", "Magangué", "Turbaco"],
    "Boyacá": ["Tunja", "Duitama", "Sogamoso", "Chiquinquirá"],
    "Caldas": ["Manizales", "Villamaría", "Chinchiná"],
    "Caquetá": ["Florencia"],
    "Casanare": ["Yopal"],
    "Cauca": ["Popayán", "Santander de Quilichao"],
    "Cesar": ["Valledupar", "Aguachica"],
    "Córdoba": ["Montería", "Lorica", "Cereté"],
    "Cundinamarca": ["Soacha", "Zipaquirá", "Facatativá", "Girardot", "Chía"],
    "Huila": ["Neiva", "Pitalito", "Garzón"],
    "La Guajira": ["Riohacha", "Maicao"],
    "Magdalena": ["Santa Marta", "Ciénaga"],
    "Meta": ["Villavicencio", "Acacías"],
    "Nariño": ["Pasto", "Tumaco", "Ipiales"],
    "Norte de Santander": ["Cúcuta", "Ocaña"],
    "Quindío": ["Armenia", "Calarcá"],
    "Risaralda": ["Pereira", "Dosquebradas", "Santa Rosa de Cabal"],
    "Santander": ["Bucaramanga", "Floridablanca", "Girón", "Barrancabermeja"],
    "Sucre": ["Sincelejo"],
    "Tolima": ["Ibagué", "Espinal"],
    "Valle del Cauca": ["Cali", "Buenaventura", "Palmira", "Tuluá", "Buga"]
  },
  "Argentina": {
    "Buenos Aires": ["Buenos Aires", "La Plata", "Mar del Plata", "Bahía Blanca", "Tandil", "Pilar"],
    "Catamarca": ["San Fernando del Valle de Catamarca"],
    "Chaco": ["Resistencia"],
    "Chubut": ["Rawson", "Comodoro Rivadavia", "Trelew"],
    "Córdoba": ["Córdoba", "Villa Carlos Paz", "Río Cuarto", "Villa María"],
    "Corrientes": ["Corrientes"],
    "Entre Ríos": ["Paraná", "Concordia"],
    "Formosa": ["Formosa"],
    "Jujuy": ["San Salvador de Jujuy"],
    "La Pampa": ["Santa Rosa"],
    "La Rioja": ["La Rioja"],
    "Mendoza": ["Mendoza", "San Rafael", "Godoy Cruz"],
    "Misiones": ["Posadas", "Puerto Iguazú"],
    "Neuquén": ["Neuquén", "San Martín de los Andes"],
    "Río Negro": ["Viedma", "San Carlos de Bariloche"],
    "Salta": ["Salta"],
    "San Juan": ["San Juan"],
    "San Luis": ["San Luis"],
    "Santa Cruz": ["Río Gallegos", "El Calafate"],
    "Santa Fe": ["Rosario", "Santa Fe"],
    "Santiago del Estero": ["Santiago del Estero"],
    "Tierra del Fuego": ["Ushuaia"],
    "Tucumán": ["San Miguel de Tucumán"]
  },
  "España": {
    "Andalucía": ["Sevilla", "Málaga", "Granada", "Córdoba", "Cádiz", "Jerez", "Almería", "Huelva", "Jaén", "Marbella"],
    "Aragón": ["Zaragoza", "Huesca", "Teruel"],
    "Asturias": ["Oviedo", "Gijón", "Avilés"],
    "Canarias": ["Las Palmas de Gran Canaria", "Santa Cruz de Tenerife", "La Laguna"],
    "Cantabria": ["Santander", "Torrelavega"],
    "Castilla y León": ["Valladolid", "Burgos", "Salamanca", "León", "Segovia", "Ávila"],
    "Castilla-La Mancha": ["Toledo", "Albacete", "Ciudad Real", "Guadalajara", "Cuenca"],
    "Cataluña": ["Barcelona", "Tarragona", "Lleida", "Girona", "Sabadell", "Terrassa"],
    "Comunidad Valenciana": ["Valencia", "Alicante", "Elche", "Castellón"],
    "Extremadura": ["Badajoz", "Cáceres", "Mérida"],
    "Galicia": ["Vigo", "A Coruña", "Santiago de Compostela", "Ourense", "Lugo", "Pontevedra"],
    "Islas Baleares": ["Palma de Mallorca", "Ibiza", "Manacor"],
    "La Rioja": ["Logroño"],
    "Madrid": ["Madrid", "Móstoles", "Alcalá de Henares", "Getafe", "Leganés", "Alcorcón"],
    "Murcia": ["Murcia", "Cartagena", "Lorca"],
    "Navarra": ["Pamplona", "Tudela"],
    "País Vasco": ["Bilbao", "San Sebastián", "Vitoria-Gasteiz", "Barakaldo"]
  },
  "Estados Unidos": {
    "California": ["Los Angeles", "San Francisco", "San Diego", "San Jose", "Sacramento"],
    "Florida": ["Miami", "Orlando", "Tampa", "Jacksonville", "Fort Lauderdale"],
    "Illinois": ["Chicago", "Aurora", "Naperville"],
    "New York": ["New York City", "Buffalo", "Albany"],
    "Texas": ["Houston", "Dallas", "Austin", "San Antonio", "El Paso"]
  },
  "Chile": {
    "Arica y Parinacota": ["Arica"],
    "Tarapacá": ["Iquique"],
    "Antofagasta": ["Antofagasta", "Calama"],
    "Atacama": ["Copiapó"],
    "Coquimbo": ["La Serena", "Coquimbo"],
    "Valparaíso": ["Valparaíso", "Viña del Mar"],
    "Metropolitana": ["Santiago", "Puente Alto", "Maipú", "Las Condes", "Providencia"],
    "O'Higgins": ["Rancagua"],
    "Maule": ["Talca"],
    "Biobío": ["Concepción", "Talcahuano", "Los Ángeles"],
    "Araucanía": ["Temuco"],
    "Los Ríos": ["Valdivia"],
    "Los Lagos": ["Puerto Montt", "Osorno"],
    "Aysén": ["Coyhaique"],
    "Magallanes": ["Punta Arenas"]
  },
  "Perú": {
    "Amazonas": ["Chachapoyas"],
    "Áncash": ["Huaraz", "Chimbote"],
    "Arequipa": ["Arequipa"],
    "Ayacucho": ["Ayacucho"],
    "Cajamarca": ["Cajamarca"],
    "Cusco": ["Cusco"],
    "Ica": ["Ica", "Nazca"],
    "Junín": ["Huancayo"],
    "La Libertad": ["Trujillo"],
    "Lambayeque": ["Chiclayo"],
    "Lima": ["Lima", "Miraflores", "San Isidro", "Barranco", "Callao"],
    "Loreto": ["Iquitos"],
    "Piura": ["Piura"],
    "Puno": ["Puno", "Juliaca"],
    "San Martín": ["Tarapoto"],
    "Tacna": ["Tacna"]
  }
};

export const getCountries = () => Object.keys(geoData).sort();

export const getStates = (country) => {
  if (!country || !geoData[country]) return [];
  return Object.keys(geoData[country]).sort();
};

export const getCities = (country, state) => {
  if (!country || !state || !geoData[country]?.[state]) return [];
  return geoData[country][state].sort();
};

export const DAYS = Array.from({ length: 31 }, (_, i) => i + 1);
export const MONTHS = [
  { value: 1, label: 'Enero' },
  { value: 2, label: 'Febrero' },
  { value: 3, label: 'Marzo' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Mayo' },
  { value: 6, label: 'Junio' },
  { value: 7, label: 'Julio' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Septiembre' },
  { value: 10, label: 'Octubre' },
  { value: 11, label: 'Noviembre' },
  { value: 12, label: 'Diciembre' }
];

const currentYear = new Date().getFullYear();
export const YEARS = Array.from({ length: 100 }, (_, i) => currentYear - 13 - i);

export const GENDERS = [
  { value: 'male', label: 'Masculino' },
  { value: 'female', label: 'Femenino' },
  { value: 'non_binary', label: 'No binario' },
  { value: 'prefer_not_say', label: 'Prefiero no decir' }
];

export default geoData;
